import * as React from "react";
import Link from "next/link";
import { portalRoutes } from "@nju/routes";
import { A, Panel, Separator, Text } from "@nju/ui";

interface ICancellationInProgressProps {
  userId: string | undefined;
}

export function CancellationInProgress({
  userId,
}: ICancellationInProgressProps) {
  return (
    <Panel>
      <div className="flex items-center flex-col">
        <Text
          align="center"
          size={{
            "@onlyMobile": "l",
            "@fromTablet": "keyM",
          }}
          weight="bold"
        >
          anulowanie
        </Text>
        <Text
          align="center"
          size={{
            "@onlyMobile": "l",
            "@fromTablet": "keyM",
          }}
          weight="bold"
        >
          przeniesienia numeru
        </Text>
        <Separator size="xs" tone="invisible" />
        <div className="flex justify-center">
          <img alt="Portout failed" src="/images/portout-success.svg" />
        </div>
        <Separator size="xs" tone="invisible" />
        <Text
          align="center"
          size={{
            "@onlyMobile": "m",
            "@fromTablet": "l",
          }}
        >
          Czekamy na informację od operatora,
        </Text>
        <Text
          align="center"
          size={{
            "@onlyMobile": "m",
            "@fromTablet": "l",
          }}
        >
          czy możemy anulować przeniesienie Twojego numeru.
        </Text>
        <Text
          align="center"
          size={{
            "@onlyMobile": "m",
            "@fromTablet": "l",
          }}
        >
          Poinformujemy Cię o tym.
        </Text>
        <Separator size="s" tone="invisible" />
      </div>
      <div className="flex flex-col from-tablet:flex-row justify-center">
        <Link
          href={portalRoutes.mojeKonto.index.get({ mode: "mobile", userId })}
          passHref={true}
        >
          <A
            size={{
              "@onlyMobile": "s",
            }}
          >
            ok
          </A>
        </Link>
      </div>
    </Panel>
  );
}
